export default "__VITE_ASSET__ZstyIp1q__"